import { z } from 'zod'

export const GetCustomAttributesSchema = z.object({
  export: z.enum(['0', '1']).nullish(),
  hubspot_link: z.string().nullish(),
  import: z.enum(['0', '1']).nullish(),
  ipaff: z.enum(['0', '1']).nullish(),
})
